import { render, staticRenderFns } from "./SurveyEmailFilter.vue?vue&type=template&id=70e87ca0&scoped=true&"
import script from "./SurveyEmailFilter.vue?vue&type=script&lang=ts&"
export * from "./SurveyEmailFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e87ca0",
  null
  
)

export default component.exports